import './sidebar.scss';
import ModalMaterial from '../modal-material/modal-material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClose } from '@fortawesome/free-solid-svg-icons'
import Button from '../../components/button/button';
import { useState, useEffect, useRef } from 'react';
import moment from 'moment';
import MATERIAL_AUDIO from '../../assets/material-audio.png';
import MATERIAL_PDF from '../../assets/material-pdf.png';
import MATERIAL_TEXT from '../../assets/material-text.png';
import NO_LIKE from '../../assets/icon-no-like.svg';
import LIKE from '../../assets/icon-like.svg';
import SupportMaterialsService from '../../services/support-materials-service';
import LocalStorage from '../../services/local-storage';
import { TEAM, SESSION } from '../../constants';
import TranslateService from '../../services/translate-service';

export default function Sidebar(props) {

    const firstUpdate = useRef(true);
    const [openModal, setOpenModal] = useState(false);
    const [showTypeText, setShowTypeText] = useState(false);
    const [isLiked, setIsLiked] = useState(null);

    const [team] = useState(LocalStorage.get(TEAM));
    const [session] = useState(LocalStorage.get(SESSION));

    useEffect(() => {
        if (firstUpdate.current) {
            firstUpdate.current = false;
            getLike();

            return;
        }
    });

    const getLike = async () => {
        try {
            const response = await SupportMaterialsService.getLike(team.area._id, session._id, props.material._id);
            setIsLiked(response.like)
        } catch (error) {
            
        }
    }

    const formatType = (type) => {
        switch (type) {
            case "VIDEO":
                return TranslateService.get('supportMaterials.type.video');
            case "IMAGEN":
                return TranslateService.get('supportMaterials.type.image');
            case "ARCHIVO":
                return TranslateService.get('supportMaterials.type.pdf');
            case "AUDIO":
                return TranslateService.get('supportMaterials.type.audio');
            case "TEXTO":
                return TranslateService.get('supportMaterials.type.text');

            default:
                return type;
        }
    }

    const thumbnail = (material) => {
        switch (material.tipo) {
            case "VIDEO":
                return material.thumbnail;
            case "IMAGEN":
                return material.url;
            case "ARCHIVO":
                return MATERIAL_PDF;
            case "AUDIO":
                return MATERIAL_AUDIO;
            case "TEXTO":
                return MATERIAL_TEXT;
        
            default:
                return 'https://via.placeholder.com/500x300';
        }
    }

    const isViewedMaterial = () => {
        try {
            SupportMaterialsService.isViewed(team.area._id, session._id, props.material._id);
            if(isLiked === null) {
                setIsLiked(false)
            }
        } catch (error) {  }
    }
   
    const handleLike = async () => {
        try {
            setIsLiked(!isLiked)
            await SupportMaterialsService.handleLike(team.area._id, session._id, props.material._id);
            
        } catch (error) {  }
    }

    const goToMaterial = () => {
        isViewedMaterial();

        if(props.material.tipo === 'TEXTO') {
            setShowTypeText(true);
            return;
        }

        if(props.material.tipo === 'ARCHIVO') {
            return window.open(props.material.url, '_blank	');
        }


        setOpenModal(true)
    }

    return (
        <>
            <ModalMaterial open={openModal} material={props.material} onClose={() => setOpenModal(false)} />

            <div className={'sidebar open'}>
            {/* <div className={'sidebar ' + (props.open ? 'open' : '')}> */}

                {props.material &&
                    <div className={'sidebar-content '}>
                        <div className='sidebar-header' style={{ backgroundImage: `url("${ thumbnail(props.material)}")` }}>
                            <button className='btn-close' onClick={props.onClose}>
                                <FontAwesomeIcon icon={faClose} />
                            </button>
                        </div>
                        <div className='sidebar-body'>
                            <div className='flex items-center'>
                                <h1 className='heading-h6 !text-default uppercase mr-4 '>{props.material.titulo}</h1>
                                
                                {isLiked !== null && 
                                <>
                                    <img src={NO_LIKE} className={ 'cursor-pointer w-[20px] ' + (isLiked === true ? 'hidden': '')} onClick={handleLike} alt=""/> 
                                    <img src={LIKE}  className={ 'cursor-pointer w-[20px] ' + (isLiked === false ? 'hidden': '')} onClick={handleLike} alt="I like it"/> 
                                </>
                                }
                                
                            </div>
                            
                            
                            <label className='text-label-light-default bg-label-light-bg py-[2px] px-[6px] font-semibold leading-[14px] rounded-[100px] text-[10px] uppercase'>{formatType(props.material.tipo)}</label>

                            <p className='text-secundary mt-2 mb-3'>{ moment(props.material.createdAt).format("DD/MM/YYYY") }</p>
                            <p className=''>{props.material.descripcion}</p>
                            
                            {showTypeText && 
                                <>
                                    <div className='separator-bottom my-5'></div>
                                    <article className="prose prose-slate" dangerouslySetInnerHTML={{ __html: props.material.url }} />
                                </>
                            }
                            
                            {props.material.tags.filter( t => t).length > 0 && 
                                <div className='mt-4'>
                                    {
                                        props.material.tags.filter( t => t).map( (t, index) => <label key={index} className='text-label-light-default bg-label-light-bg py-[2px] px-[6px] font-semibold leading-[14px] rounded-[100px] text-[10px] mr-3'>{t}</label>)
                                    }
                                </div>
                            }
                            

                            {!showTypeText && 
                                <Button className="small mt-8" onClick={goToMaterial} >
                                    {TranslateService.get('supportMaterials.detail.btn')}
                                </Button>
                            }
                            
                        </div>
                    </div>
                }
            </div>
        </>
    );
}
